module.exports = __webpack_public_path__ + "media/assets/avia/search/fix-date-8184cd0f0134d90bc6320c54f4e30112.png";